import axiosGraphQL from './GraphQL/axiosGraphQL';
import * as RoleQuery from './GraphQL/Queries/roleQuery';
import { IGetAllRoleParams, ROLE_VARIABLES } from './GraphQL/Variables/role';

const RoleApi = {
  getAllRoleComboBox: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RoleQuery.GET_ALL_ROLE_COMBOBOX,
    });
  },
  getAllRoleByFilter: async (params: IGetAllRoleParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: RoleQuery.GET_ALL_ROLE_BY_FILTER,
      variables: ROLE_VARIABLES.GET_ALL_ROLE_BY_FILTER(params),
    });
  },
};

export default RoleApi;
